<template>
  <div class="register">
    <div class="register_school_icon">
      <img alt="" src="../assets/imgs/loginSchoolIconNew.png" width="726">
    </div>
    <div class="register_systmeName">{{ title }}</div>
    <div class="register_form">
      <div class="register_form_title">注册</div>
      <div class="register_form_back" @click="goLogin">登录</div>
      <el-form ref="ruleForm" :model="ruleForm" :rules="rules" class="demo-ruleForm" label-position="left"
               label-width="130px">
        <el-form-item label="学生姓名：" prop="name">
          <el-input v-model="ruleForm.name" @keydown.native.space.prevent></el-input>
        </el-form-item>
        <el-form-item label="教育ID号：" prop="eduId">
          <el-input v-model="ruleForm.eduId" @keydown.native.space.prevent></el-input>
        </el-form-item>
        <el-form-item label="密码：" prop="password">
          <el-input v-model="ruleForm.password" type="password" @keydown.native.space.prevent></el-input>
        </el-form-item>
        <el-form-item label="再次输入密码：" prop="checkPwd">
          <el-input v-model="ruleForm.checkPwd" type="password" @keydown.native.space.prevent></el-input>
        </el-form-item>
        <el-form-item label="手机号：" prop="mobilePhone">
          <el-input v-model="ruleForm.mobilePhone" @keydown.native.space.prevent></el-input>
        </el-form-item>
        <el-form-item class="validateCode" label="验证码：" prop="validateCode">
          <el-input v-model="ruleForm.validateCode" @keydown.native.space.prevent></el-input>
          <div v-if="imageVerifyUrl" class="codeImg" @click="getImgCode">
            <img :src="imageVerifyUrl" alt="" height="100%" width="100%">
          </div>
        </el-form-item>
        <el-form-item class="messageValidateCode" label="短信验证码：" prop="mobilePhoneValidateCode">
          <el-input v-model="ruleForm.mobilePhoneValidateCode" @keydown.native.space.prevent></el-input>
          <el-button :class="identityClass" class="purple" type="primary" @click="getMobileCode">{{ identityText }}
          </el-button>
        </el-form-item>
        <el-form-item class="operate">
          <el-button :disabled="registerDisable" class="purple" type="primary" @click="register('ruleForm')">注册
          </el-button>
        </el-form-item>
      </el-form>
    </div>
  </div>
</template>

<script>
import Vue from 'vue'
import { Button, Form, FormItem, Input, Message } from 'element-ui'
import { decryptWithSignature } from "@/util";

Vue.use(Form).use(FormItem).use(Input).use(Button)
export default {
  name: 'register',
  data () {
    // 自定义校验密码输入
    const validateModPass1 = (rule, value, callback) => {
      if (this.ruleForm.checkPwd.trim() !== '') {
        this.$refs.ruleForm.validateField('checkPwd')
      }
      callback()
    }
    // 自定义校验确认密码输入
    const validateModPass2 = (rule, value, callback) => {
      if (value.trim() !== this.ruleForm.password.trim() && this.ruleForm.checkPwd.trim()) {
        callback(new Error('两次输入密码不一致!'))
      } else {
        callback()
      }
    }
    // 不允许空格
    const noSpaceValidator = (rule, value, callback) => {
      if (value && /\s/.test(value)) {
        callback(new Error('不允许包含空格'))
      } else {
        callback()
      }
    }
    return {
      title: '',
      ruleForm: {
        name: '',
        eduId: '',
        password: '',
        checkPwd: '',
        validateCode: '',
        mobilePhone: '',
        mobilePhoneValidateCode: ''
      },
      rules: {
        name: [{
          required: true,
          message: '请输入学生姓名',
          trigger: 'blur'
        }, {
          validator: noSpaceValidator,
          trigger: 'blur'
        }],
        eduId: [{
          required: true,
          message: '请输入教育ID号',
          trigger: 'blur'
        }, {
          validator: noSpaceValidator,
          trigger: 'blur'
        }],
        password: [{
          required: true,
          message: '请输入密码',
          trigger: 'blur'
        }, {
          validator: validateModPass1,
          trigger: 'blur'
        }, {
          min: 8,
          message: '请输入8位数及以上的密码',
          trigger: 'blur'
        }, {
          validator: noSpaceValidator,
          trigger: 'blur'
        }],
        checkPwd: [{
          required: true,
          message: '请再次输入密码',
          trigger: 'blur'
        }, {
          validator: validateModPass2,
          trigger: 'blur'
        }, {
          validator: noSpaceValidator,
          trigger: 'blur'
        }],
        mobilePhone: [{
          required: true,
          message: '请输入手机号',
          trigger: 'blur'
        }, {
          min: 11,
          max: 11,
          message: '请输入正确的手机号',
          trigger: 'blur'
        }, {
          validator: noSpaceValidator,
          trigger: 'blur'
        }],
        validateCode: [{
          required: true,
          message: '请输入验证码',
          trigger: 'blur'
        }, {
          validator: noSpaceValidator,
          trigger: 'blur'
        }],
        mobilePhoneValidateCode: [{
          required: true,
          message: '请输入手机验证码',
          trigger: 'blur'
        }, {
          validator: noSpaceValidator,
          trigger: 'blur'
        }]
      },
      imageVerifyToken: '',
      imageVerifyUrl: '',
      identityText: '获取验证码',
      // 验证码60s倒计时
      countdown: 60,
      // 获取验证码按钮的class
      identityClass: 'identityInitial',
      registerDisable: false
    }
  },
  methods: {
    // 注册
    register (form) {
      const that = this
      this.$refs[form].validate((valid) => {
        if (valid) {
          that.registerDisable = true
          that.ruleForm.validateToken = that.imageVerifyToken
          that.$axios.post(window.baseURL + '/galaxy/baoming/api/v1/huaxia/applicant/regedit', that.ruleForm)
            .then(result => {
              const res = result.data
              const url = window.location.href
              const params = new URL(url).searchParams
              const batchId = params.get('batchId')
              const map = {

                VUE_APP_BATCHID_ART: '/art',

                VUE_APP_BATCHID_SCIENCE: '/science',

                VUE_APP_BATCHID_SPORT: '/sport'
              }
              if (result.code === '1000000' && res && JSON.stringify(res) !== '{}') {
                Message(
                  {
                    type: 'success',
                    message: '注册成功,即将跳转',
                    duration: 800,
                    onClose () {
                      that.$router.push(
                        {
                          path: map[decryptWithSignature(batchId)],
                          query: {
                            applicationId: res.applicationId || '',
                            applicantToken: res.applicantToken,
                            batchState: res.batchState,
                            fillEnable: res.fillEnable ? 1 : 0,
                            batchId
                          }
                        }
                      )
                    }
                  }
                )
              } else {
                that.registerDisable = false
                that.getImgCode()
              }
            })
            .catch(err => {
              console.log(err)
              that.registerDisable = false
            })
        }
      })
    },
    // 返回登录
    goLogin () {
      const url = window.location.href
      const params = new URL(url).searchParams
      const batchId = params.get('batchId')
      this.$router.push({
        path: '/login',
        query: { batchId }
      })
    },
    // 获取图形验证码
    getImgCode () {
      const url = window.location.href
      const params = new URL(url).searchParams
      const batchId = params.get('batchId')
      const map = {

        VUE_APP_BATCHID_ART: '2026年中招艺术特长生报名',

        VUE_APP_BATCHID_SCIENCE: '2026年中招科技特长生报名',

        VUE_APP_BATCHID_SPORT: '2026年中招体育特长生报名'
      }
      this.title = map[decryptWithSignature(batchId)]
      if (!batchId) {
        this.$router.replace({
          path: '/'
        })
        return
      }
      this.$axios.get(window.baseURL + `/galaxy/baoming/api/v1/huaxia/applicant/generateValidateCode`)
        .then(result => {
          const res = result.data
          if (result.code === '1000000' && res && JSON.stringify(res) !== '{}') {
            this.imageVerifyToken = res.imageVerifyToken
            this.imageVerifyUrl = res.url
          } else {
            this.imageVerifyToken = ''
            this.imageVerifyUrl = ''
          }
        })
    },
    // 获取短信验证码
    getMobileCode () {
      const that = this
      if (that.ruleForm.validateCode) {
        if (that.countdown === 60) {
          that.$axios.post(window.baseURL + '/galaxy/baoming/api/v1/huaxia/applicant/sendMobilePhoneValidateCode',
            {
              imageTokenCode: that.imageVerifyToken,
              imageValidateCode: that.ruleForm.validateCode,
              mobilePhone: that.ruleForm.mobilePhone
            }).then(result => {
            const res = result.data
            if (result.code === '1000000' && res) {
              Message({
                type: 'success',
                message: '验证码已发送，请注意查收',
                duration: 800
              })
              that.identityClass = 'identityFinal'
              const interval = setInterval(() => {
                if (that.countdown === 0) {
                  that.identityText = '重新获取'
                  that.countdown = 60
                  that.identityClass = 'identityInitial'
                  clearInterval(interval)
                } else {
                  that.countdown--
                  that.identityText = that.countdown + 's'
                }
              }, 1000)
            } else {
              that.getImgCode()
            }
          })
        } else {
          Message({
            type: 'warning',
            message: '不能重复点击！',
            duration: 800
          })
        }
      } else {
        Message({
          type: 'warning',
          message: '请先填写图形验证码',
          duration: 800
        })
      }
    }
  },
  created () {
    this.getImgCode()
  }
}
</script>

<style lang="scss" scoped>
.register {
  width: 100vw;
  min-height: 100vh;
  background: #EDF3F7;
  padding-top: 4%;
  padding-bottom: 4%;
  overflow-y: auto;

  .register_school_icon {
    display: flex;
    justify-content: center;
    margin-bottom: 20px;
  }

  .register_systmeName {
    text-align: center;
    color: #474747;
    font-size: 32px;
  }

  .register_form {
    width: 486px;
    margin: 50px auto 0;
    background-color: #fff;
    padding: 20px 36px;
    border-radius: 10px;
    position: relative;

    .register_form_title {
      font-size: 24px;
      color: #353535;
      margin-bottom: 24px;
    }

    .register_form_back {
      position: absolute;
      top: 30px;
      right: 36px;
      color: #1890FF;
      cursor: pointer;
      font-size: 16px;
    }

    .el-input {
      height: 32px;
      line-height: 32px;

      ::v-deep .el-input__inner {
        height: 32px;
        line-height: 32px;
      }
    }

    .messageValidateCode {
      .el-button {
        float: right;
        width: 102px;
        height: 32px;
        text-align: center;
        padding: 0;
      }

      .el-input {
        float: left;
        width: 174px;

        ::v-deep .el-input__inner {
          width: 174px;
        }
      }
    }

    .validateCode {
      .codeImg {
        width: 94px;
        height: 32px;
        background-color: rgba(226, 134, 148, 1);
        cursor: pointer;
        float: right;
      }

      .el-input {
        float: left;
        width: 183px;

        ::v-deep .el-input__inner {
          width: 183px;
        }
      }
    }

    .operate {
      text-align: center;

      ::v-deep .el-form-item__content {
        margin-left: 0 !important;
      }

      .el-button {
        width: 198px;
      }

      .el-button + .el-button {
        margin-left: 16px;
      }
    }

    .identityFinal {
      border-color: #37BFFF !important;
      color: #fff !important;
      background-color: #37BFFF !important;
    }

    .purple {
      background-color: #1890FF !important;
      border-color: #1890FF !important;

      &:hover {
        background-color: #1890FF;
        border-color: #1890FF;
        color: #fff;
      }
    }

    .default:hover {
      background: #FFF;
      border: 1px solid #DCDFE6;
      color: #606266;
    }
  }
}
</style>
